export interface MemorialTab {
  label: string;
  content: string;
  id: string;
}

export const memorialTabs: MemorialTab[] = [
  { id: "features", label: "Features", content: "" },
  { id: "livestream", label: "Livestream", content: "" },
  { id: "obituary", label: "Obituary", content: "" },
  { id: "timeline", label: "Timeline", content: "" },
  { id: "chema", label: "CHEMA", content: "" },
  { id: "favorites", label: "Favorites", content: "" },
  { id: "memories", label: "Memories", content: "" },
  { id: "gallery", label: "Gallery", content: "" },
];
